import { registerIconLibrary } from '@shoelace-style/shoelace';
import { SlVariant } from './slUtils';

export interface AppIcon {
  library: string;
  name: string;
}

// Font Awesome icons used in the app
// https://fontawesome.com/search?m=free&o=r

export const APP_ICON_MAGNIFIER: AppIcon = {
  library: 'fa',
  name: 'fas-magnifying-glass'
};
export const APP_ICON_COMMENT: AppIcon = { library: 'fa', name: 'fas-comment' };
export const APP_ICON_X_AXIS: AppIcon = {
  library: 'fa',
  name: 'fas-left-right'
};
export const APP_ICON_Y_AXIS: AppIcon = { library: 'fa', name: 'fas-up-down' };
export const APP_ICON_MOON: AppIcon = { library: 'fa', name: 'fas-moon' };
export const APP_ICON_SUN: AppIcon = { library: 'fa', name: 'fas-sun' };
export const APP_ICON_CHECK: AppIcon = { library: 'fa', name: 'fas-check' };
export const APP_ICON_PLUS: AppIcon = { library: 'fa', name: 'fas-plus' };
export const APP_ICON_HAND: AppIcon = { library: 'fa', name: 'fas-hand' };
export const APP_ICON_ARROW_POINTER: AppIcon = {
  library: 'fa',
  name: 'fas-arrow-pointer'
};
export const APP_ICON_UP_DOWN_LEFT_RIGHT: AppIcon = {
  library: 'fa',
  name: 'fas-up-down-left-right'
};
export const APP_ICON_UNDO: AppIcon = {
  library: 'fa',
  name: 'fas-arrow-rotate-left'
};
export const APP_ICON_REDO: AppIcon = {
  library: 'fa',
  name: 'fas-arrow-rotate-right'
};
export const APP_ICON_INFO: AppIcon = {
  library: 'fa',
  name: 'fas-circle-info'
};
export const APP_ICON_GEAR: AppIcon = { library: 'fa', name: 'fas-gear' };
export const APP_ICON_WARNING: AppIcon = {
  library: 'fa',
  name: 'fas-triangle-exclamation'
};
export const APP_ICON_DANGER: AppIcon = {
  library: 'fa',
  name: 'fas-circle-xmark'
};
export const APP_ICON_LEFT_TO_RIGHT: AppIcon = {
  library: 'fa',
  name: 'fas-right-long'
};
export const APP_ICON_TOP_TO_BOTTOM: AppIcon = {
  library: 'fa',
  name: 'fas-down-long'
};
export const APP_ICON_RIGHT_TO_LEFT: AppIcon = {
  library: 'fa',
  name: 'fas-left-long'
};
export const APP_ICON_BOTTOM_TO_TOP: AppIcon = {
  library: 'fa',
  name: 'fas-up-long'
};
export const APP_ICON_UNCONSTRAINED: AppIcon = {
  library: 'fa',
  name: 'fas-right-left'
};
export const APP_ICON_PANEL_LEFT: AppIcon = {
  library: 'fa',
  name: 'fas-angles-left'
};
export const APP_ICON_PANEL_RIGHT: AppIcon = {
  library: 'fa',
  name: 'fas-angles-right'
};
export const APP_ICON_PANEL_UP: AppIcon = {
  library: 'fa',
  name: 'fas-angles-up'
};
export const APP_ICON_PANEL_DOWN: AppIcon = {
  library: 'fa',
  name: 'fas-angles-down'
};
export const APP_ICON_MENU: AppIcon = { library: 'fa', name: 'fas-bars' };

export function registerIcons() {
  registerIconLibrary('fa', {
    resolver: name => {
      const filename = name.replace(/^fa[rbs]-/, '');
      let folder = 'regular';
      if (name.startsWith('fas-')) folder = 'solid';
      if (name.startsWith('fab-')) folder = 'brands';
      return `/fontawesome/${folder}/${filename}.svg`;
    },
    mutator: svg => {
      svg.setAttribute('fill', 'currentColor');
    }
  });
}

export function iconForSlVariant(variant: SlVariant): AppIcon {
  let icon: AppIcon;
  switch (variant) {
    case SlVariant.PRIMARY:
      icon = APP_ICON_INFO;
      break;
    case SlVariant.SUCCESS:
      icon = APP_ICON_CHECK;
      break;
    case SlVariant.NEUTRAL:
      icon = APP_ICON_GEAR;
      break;
    case SlVariant.WARNING:
      icon = APP_ICON_WARNING;
      break;
    case SlVariant.DANGER:
      icon = APP_ICON_DANGER;
      break;
  }
  return icon;
}
